/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Education
 */
export interface Education {
    /**
     * 
     * @type {string}
     * @memberof Education
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof Education
     */
    imported: boolean;
    /**
     * 
     * @type {string}
     * @memberof Education
     */
    degree?: string;
    /**
     * 
     * @type {string}
     * @memberof Education
     */
    school?: string;
    /**
     * 
     * @type {number}
     * @memberof Education
     */
    graduationYear?: number;
    /**
     * 
     * @type {string}
     * @memberof Education
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Education
     */
    current: boolean;
}

/**
 * Check if a given object implements the Education interface.
 */
export function instanceOfEducation(value: object): value is Education {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('imported' in value) || value['imported'] === undefined) return false;
    if (!('current' in value) || value['current'] === undefined) return false;
    return true;
}

export function EducationFromJSON(json: any): Education {
    return EducationFromJSONTyped(json, false);
}

export function EducationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Education {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'imported': json['imported'],
        'degree': json['degree'] == null ? undefined : json['degree'],
        'school': json['school'] == null ? undefined : json['school'],
        'graduationYear': json['graduationYear'] == null ? undefined : json['graduationYear'],
        'description': json['description'] == null ? undefined : json['description'],
        'current': json['current'],
    };
}

export function EducationToJSON(value?: Education | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'imported': value['imported'],
        'degree': value['degree'],
        'school': value['school'],
        'graduationYear': value['graduationYear'],
        'description': value['description'],
        'current': value['current'],
    };
}

